<template>
  <vs-wrapper space="small">
    <vs-text class="date-heading">{{ formattedDate }}</vs-text>
    <v-timeline class="pt-3" dense>
      <activity-log-item
        v-for="formattedChange in formattedChanges"
        :key="formattedChange.uuid"
        :formatted-change="formattedChange"
      />
    </v-timeline>
  </vs-wrapper>
</template>

<script setup lang="ts">
import { useFormattedChanges } from './composables/useFormattedChanges'
import JobHistory from '@/models/job-history'
import ActivityLogItem from './ActivityLogItem.vue'
import { CustomFieldRecord } from '@/models/types/custom-field'

// Define your props
const props = withDefaults(
  defineProps<{
    date: string | number
    changes: JobHistory[]
    jobStart?: object | null
    jobEnd?: object | null
    jobHubId: string
    customFieldDefinitions?: CustomFieldRecord
  }>(),
  {
    changes: () => [],
    jobStart: null,
    jobEnd: null,
    customFieldDefinitions: undefined,
  },
)

const { formattedDate, formattedChanges } = useFormattedChanges(props)
</script>

<style scoped>
.date-heading {
  padding-left: 96px;
}

.v-timeline::before {
  top: 50px;
  height: calc(100% - 100px);
}
</style>
